var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('formulario-cliente',{attrs:{"pais":_vm.pais,"cliente":_vm.cliente,"imagenes":_vm.imagenes,"contactos":_vm.contactos},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }